import axios from 'axios';
import Auth from '../auth';
export const url = "";

axios.interceptors.response.use (
    (response) => {
        return response;
    }, (error) => {
        if (error.response !== undefined && 401 === error.response.status) {
            Auth.logout();
            window.location.href = "/login";
        } else {
            return Promise.reject(error);
        }
    }
);

export const loginApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/account/login`,
            data: request
        }).then(response => {
            const AUTH_TOKEN = 'Bearer ' + response.data.token;
            window.localStorage.setItem("token", AUTH_TOKEN);
            axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getGrupoPlanesById = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes/Planes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getGrupoById = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const deleteGrupoPlanesById = (id) => {
    
    return new Promise((resolve, reject) => {
        
        axios({
            method: 'delete',
            url: `${url}/api/Administracion/GrupoPlanes?id=${id}`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getGrupoPlanes = (params) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getPlanesPorParametros = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/Planes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/GrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/GrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchDashboardTotalizadoresApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Landing/Dashboard/Totalizadores`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const obtenerUsuariosDeSeller = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/Buscar`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postSearchUsuario = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/ObtenerUsuario`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postChangeStateUsuario = (data) => {
    console.log(data, "🎀")
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CambiarEstado`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const modificarUsuario = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postTiposPublicacionAsociarGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion/AsociarGrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postTiposPublicacionAsociarSeller = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion/AsociarSeller`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getTiposPublicacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/TiposPublicacion`,
            params: request
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAdministracionTiposPublicacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putAdministracionTiposPublicacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/TiposPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const deleteAdministracionTiposPublicacion = (id) => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'delete',
            url: `${url}/api/Administracion/TiposPublicacion?id=${id}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postFacturaOrdenes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}


export const postCrearOrden = (data) => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'post',
            url: `${url}/api/Ordenes/CrearOrden`,
            data: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getFacturaOrdenes = (idOrden, idEstado) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/Comprobantes?IdOrden=${idOrden}&IdEstado=${idEstado}`,
        }
        ).then(response => {
            
            response.data.comprobantes.map((item) => {
                if (item.idEstado == idEstado) {
                    resolve(item.archivo);
                }
            })
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getComprobanteOrdenes = (idOrden) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Obleas?idOrden=${idOrden}`,
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchSellersApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchProveedoresApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/Proveedores`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchPublicacionesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones`,
            params: {
                ...params,
                DireccionOrdenamiento: 1,
                EntidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            
            resolve(response.data)
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchTipoPublicacionApi = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Publicacion`,
            params: { idSeller: idSeller }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchPublicacionApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones`,
            params: {
                idPublicacion: id,
            }
        }).then(response => {
            
            setTimeout(() => { resolve(response.data) }, 1000)
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchVariacionesApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Estados/Variaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchMarcasApi = (descripcion) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/Marcas`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                descripcion: descripcion
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchMarcaApi = (idMarca) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                id: idMarca
            },
        }).then(response => {
            
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
}


export const fetchCategoriasApi = (descripcion) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/SubFamiliasByParams`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                descripcion: descripcion
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchCategoriaApi = (idCategoria) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/SubFamilias`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                id: idCategoria
            },
        }).then(response => {
            
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
}

export const createPublicacionApi = (publicacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones`,
            data: publicacion
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updatePublicacionApi = (publicacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones`,
            data: publicacion
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updateImagenesApi = (request) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizarImagenes`,
            data: request
        }).then(response => {

            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updatePosicionesImagenesApi = (request) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizarPosicionImagenes`,
            data: request
        }).then(response => {

            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const deletePublicacionApi = (id) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Publicaciones?id=${id}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchMotivosRevisionApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/MotivosRevision`
        }).then((response) => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchMotivosSolicitudAnulacionApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/MotivosSolicitudAnulacion`
        }).then((response) => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const updatePublicacionEstadoVariacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/Variaciones`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postAprobarPublicacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/Aprobar`,
            data: request
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postDesaprobarPublicacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/Desaprobar`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deleteSellerApi = (id) => {
    return new Promise((resolve, reject) => {
        
        axios({
            method: 'delete',
            url: `${url}/api/Seller?id=${id}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const getOrden = (idOrden) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes?IdOrden=${idOrden}&NumeroPagina=1&CantidadPagina=100`,
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenesParams = (request) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenesEnVerdeParams = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/OrdenesVentaVerde`,
            params: request
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObtenerEstadoVenta`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAnularOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AnularEstadoVenta`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postAprobarOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AprobarEstadoVenta`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postSolicitudAnulacionOrdenApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/SolicitudAnulacion`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postAnulacionReversionOrdenApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AnulacionReversion`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const listSellers = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const listSellersParameters = (Descripcion, CantidadPagina, NumeroPagina) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar?Descripcion=${Descripcion}&CantidadPagina=${CantidadPagina}&NumeroPagina=${NumeroPagina}`
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getSeller = (IdSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar?IdSeller=${IdSeller}&NumeroPagina=1&CantidadPagina=1`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getIntegradores = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Integrators`,
        }).then(response => {
            resolve(response.data.integradores);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getTipoFacturacion = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Facturacion`,
        }).then(response => {
            resolve(response.data.tiposFacturacion);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getEstadosSeller = () => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Estados/Seller`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postSeller = (data) => {

    let seller = {
        "estado": data.estado,
        "idIntegrador": data.integrador?.codigo != null ? parseInt(data.integrador.codigo) : 1,
        "sufijo": data.sufijo,
        "idEmpresaEnviopack": parseInt(data.idEmpresaEnviopack),
        "idTipoFacturacion": parseInt(data.tipoFacturacion),
        "razonSocial": data.razonSocial,
        "domicilio": data.domicilio,
        "numeroDomicilio": parseInt(data.numeroDomicilio),
        "localidad": data.localidad,
        "provincia": data.provincia,
        "codigoPostal": parseInt(data.codigoPostal),
        "telefono": data.telefono,
        "cuit": data.cuit,
        "email": data.email,
        "emailDespacho": data.email,
        "urlPushOrdenes": data.urlPushOrdenes,
        "emailUsuario": data.emailUsuario,
        "diasPlazoPago": data.diasPlazoPago,
        "diasCorte": data.diasCorte,
        "usuario": data.nombreUsuario,
        "password": data.password,
        "tiendaActiva": data.tiendaActiva,
        "envioPropio": data.envioPropio
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller`,
            data: seller
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postUser = (data) => {

    let seller = {
        "idUsuario": data.idUsuario,
        "idSeller": data.idSeller,
        "password": data.password,
        "usuario": data.usuario,
        "email": data.email,
        "enviarMail": data.enviarEmail,
        "tipoUsuario": data.tipoUsuario,
        "soloLectura": data.soloLectura,
        "idProveedor": data.idProveedor
    };

    return new Promise((resolve, reject) => {

        axios({
            method: 'post',
            url: `${url}/api/Usuarios`,
            data: seller
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const editUser = (data) => {

    let seller = {
        "idUsuario": data.idUsuario,
        "idSeller": data.idSeller,
        "nuevoPassword": data.password,
        "usuario": data.usuario,
        "email": data.email,
        "soloLectura": data.soloLectura,
        "identificadores": data.identificadores,
    };

    return new Promise((resolve, reject) => {

        axios({
            method: 'put',
            url: `${url}/api/Usuarios`,
            data: seller
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })

}

export const putSeller = (data) => {

    if (data.integrador.codigo != null) {
        data.integrador = data.integrador.codigo;
    }

    if (data.tipoFacturacion.codigo != null) {
        data.tipoFacturacion = data.tipoFacturacion.codigo;
    }
    
    let seller = {
        "idSeller": data.codigo,
        "idIntegrador": parseInt(data.integrador),
        "idTipoFacturacion": parseInt(data.tipoFacturacion),
        "sufijo": data.sufijo,
        "idEmpresaEnviopack": parseInt(data.idEmpresaEnviopack),
        "estado": data.estado,
        "razonSocial": data.razonSocial,
        "domicilio": data.domicilio,
        "numeroDomicilio": parseInt(data.numeroDomicilio),
        "localidad": data.localidad,
        "provincia": data.provincia,
        "codigoPostal": parseInt(data.codigoPostal),
        "telefono": data.telefono,
        "cuit": data.cuit,
        "email": data.email,
        "emailUsuario": data.emailUsuario,
        "nombreUsuario": data.nombreUsuario,
        "emailDespacho": data.emailDespacho,
        "urlPushOrdenes": data.urlPushOrdenes,
        "diasPlazoPago": data.diasPlazoPago != "" ? parseInt(data.diasPlazoPago) : 0,
        "diasCorte": data.diasCorte != "" ? parseInt(data.diasCorte) : 0,
        "logo": data.logo,
        "nombreTienda": data.nombreTienda,
        "tiendaActiva": data.tiendaActiva,
        "envioPropio": data.envioPropio
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller`,
            data: seller
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const createImageUrl = (img) => {

    if (img.type.includes("image")) {
        let form = new FormData();

        form.append('', img, img.name);

        return new Promise(resolve => {
            axios({
                "url": "/Imagen",
                "method": "POST",
                "timeout": 0,
                "processData": false,
                "mimeType": "multipart/form-data",
                "contentType": false,
                "data": form
            }).then(res => {
                resolve(res.data);
            })
        })
    } else {
        return new Promise(reject => {
            reject("Archivo incorrecto");
        })
    }
}

export const createImageSellerUrl = (img) => {

    if (img.type.includes("image")) {
        let form = new FormData();

        form.append('', img, img.name);

        return new Promise(resolve => {
            axios({
                "url": "/Imagen/Seller",
                "method": "POST",
                "timeout": 0,
                "processData": false,
                "mimeType": "multipart/form-data",
                "contentType": false,
                "data": form
            }).then(res => {
                resolve(res.data);
            })
        })
    } else {
        return new Promise(reject => {
            reject("Archivo incorrecto");
        })
    }
}

export const leerExcelPublicaciones = (formularioCompleto) => {
    return new Promise(resolve => {
        axios({
            "dataType": "html",
            "url": "/PublicacionesExcel",
            "method": "POST",
            "timeout": 0,
            "processData": false,
            "contentType": false,
            "data": formularioCompleto
        }).then(res => {
            resolve(res);
        })
    });
}

export const leerExcelPublicacionesPorCodigo = (formularioCompleto) => {
    return new Promise(resolve => {
        axios({
            "dataType": "html",
            "url": "/PublicacionesExcelPorCodigo",
            "method": "POST",
            "timeout": 0,
            "processData": false,
            "contentType": false,
            "data": formularioCompleto
        }).then(res => {
            resolve(res);
        })
    });
}

export const postCreacionMasivaPublicacionesApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CreacionMasiva`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postExcelPublicaciones = (data) => {

    let listaAtributos = {
        "listaAtributos": data
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasiva`,
            data: listaAtributos
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postExcelPublicacionesModerador = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaPorCodigo`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putExcelPublicacionesTipoYEnvioApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaTipoYEnvio`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putExcelLiquidacionesFeeLogisticoApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionMasivaFeeLogistico`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getFeeLogisticoSellersApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/FeeLogistico`
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchRebatesDeLiquidacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/Rebates`,
            params: request
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLocalidades = (params) => {
    let params_1 = { ...params, NumeroPagina: 1, CantidadPagina: 500 };
    return new Promise((resolve) => {
        axios({
            method: 'get',
            url: `${url}/api/Localidades`,
            params: (params_1) ? params_1 : null
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            resolve(error);
        })
    })
}

export const getSituacionIva = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/SituacionIva`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}


export const getTiposAdquirientes = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Adquirientes`
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getTiposSexo = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Sexo`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionesListaSellers = () => {
    return new Promise((resolve, reject) => {
        
        axios({
            method: 'get',
            url: `${url}/api/Seller/TraerSellerLiquidaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getTiposConceptos = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/TraerConceptoNovedad`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionporid = (request) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ConsultarDetalleLiquidacion`, 
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getOrdenesParaNuevaLiquidacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarOrdenesPorFecha`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getNovedadesParaNuevaLiquidacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarNovedades`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getLiquidacionPorIdOrdenes = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarOrdenesDeLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLogistica = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/Cotizaciones`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionPorIdNovedades = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarNovedadesDeLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postNovedad = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaLiquidacionFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearLiquidacionFinal`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaLiquidacionFinalLogistica = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/EnvioPack/Cotizaciones`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaNovedadConcepto = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearNovedadConcepto`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getAccionesLiquidaciones = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TraerAccionesNovedades`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getEstadosLiquidaciones = () => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TraerEstadosLiquidaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getEstadosLiquidacionesCorrecto = () => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TraerEstadosLiquidacionesCorrecto`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getResultadosLiquidaciones = (request) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarNovedades`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLiquidacionesBusqueda = (request) => {
    
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/LiquidacionesBusqueda`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaNovedadFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/AnularNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaConceptoFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/AnularConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaLiquidacionFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EliminarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaConceptoFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizarConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaLiquidacion = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EditarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaNovedadImporte = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EditarNovedad`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putConfirmaNovedad = (data) => {
        
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ConfirmaNovedad`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchExportarPublicacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Exportables/ExportarPublicaciones`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarOrdenesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Exportables/ExportarOrdenes`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarOrdenesTelefonicasApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExportarOrdenesTelefonicas`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarLiquidacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExportarLiquidaciones`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarSellersApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Exportables/ExportarSellers`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarMarcasApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExportarMarcas`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarCategoriasApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExportarCategorias`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const requestTokenResetPassword = (Email) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/Api/Usuarios/TokenResetPassword?Email=${Email}&IdTipoUsuario=0`
        }).then(response => {
            const AUTH_TOKEN = 'Bearer ' + response.data.token;
            window.localStorage.setItem("token", AUTH_TOKEN);
            axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchTotalNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Landing/Notificaciones/Total`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchDetalleNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Notificaciones/Detalle`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchMarcarLeidasNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Notificaciones/MarcarLeidas`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchAjusteNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Notificaciones/Ajustes`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateAjusteNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Notificaciones/Ajustes`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Rebates/Buscar`,
            params: {IdPublicacion: request}
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchListRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Rebates/ListarRebates`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Rebates/Nuevo`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Rebates/Modificar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const deleteRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Rebates?id=${request}`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postAprobarRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Rebates/Aprobar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchComprobanteVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObleaVentaVerde`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const guardarDescargaObleaVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ObleaVentaVerde`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchLogisticaPropiaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/LogisticaPropia`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateLogisticaPropiaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/LogisticaPropia`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}
export const descargarObleaVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/DescargarObleaVentaVerde`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchGarantiasApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Garantias`,
            params:request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const updateUrlTrackingApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ActualizarUrlTracking`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const putEstadoSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller/CambiarEstadoSeller`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}